import axios from "axios";
import { disableEventElement, enableEventElement } from "./module/disable";
import { BtixConstant } from "./constant";
/**
 * ログイン及びログアウトボタンの初期化を行う
 */
export const initAuthButtons = () => {
    activateLoginButton();
    activateLogoutButtons();
};
/**
 * ログイン処理
 *
 * ログインは必ずページ内に1つだけフォームがあることを想定している。
 * 複数ボタンがあるとどの要素を見に行けばいいかわからなくなるため。
 */
const activateLoginButton = () => {
    const loginButton = document.querySelector("#loginButton");
    if (!loginButton)
        return;
    const email = document.querySelector("#loginEmail");
    if (!email)
        throw new Error("'email' is not found.");
    const password = document.querySelector("#loginPassword");
    if (!password)
        throw new Error("'password' is not found.");
    const seriesPath = document.querySelector("#seriesPath");
    const eventCode = document.querySelector("#eventCode");
    const redirectFrom = document.querySelector("#redirectFrom");
    // initialize
    if (BtixConstant.debugMode)
        window.console.log("initialize: loginButton", loginButton);
    loginButton.addEventListener(BtixConstant.touchOrClickEvent(), (event) => {
        disableEventElement(event);
        const sendData = {
            email: email.value,
            password: password.value,
            series_path: seriesPath ? seriesPath.value : '',
            event_code: eventCode ? eventCode.value : '',
            redirect_from: redirectFrom ? redirectFrom.value : '',
            type: BtixConstant.loginUserType,
        };
        axios
            .post(BtixConstant.apiUrl.logIn, sendData, { withCredentials: true })
            .then((response) => {
            window.console.log(response);
            if (response.data.redirect != undefined) {
                window.location.href = response.data.redirect;
            }
            else if (event.target.dataset.redirectUrl.indexOf(seriesPath.value) !== -1) {
                window.location.href = event.target.dataset.redirectUrl;
            }
            else {
                window.location.href = seriesPath.value + '/webooth/top/index';
            }
        })
            .catch((error) => {
            if (!("isAxiosError" in error)) {
                window.console.log(error);
                throw new Error("Error occured.");
            }
            if (error.response && error.response.status === 401) {
                alert(error.response.data.message);
            }
            if (BtixConstant.debugMode)
                window.console.log(error.response);
            const response = error.response;
            const errors = response.data.errors;
            const keys = {
                // __base__: email,
                email: email,
                password: password,
            };
            const errorClass = "form-error";
            for (const [key, element] of Object.entries(keys)) {
                const area = element.closest(".form-text");
                if (!area)
                    throw new Error("'area' is not found.");
                const message = area.querySelector(".form-message");
                if (!message)
                    throw new Error("'message' is not found.");
                area.classList.remove(errorClass);
                if (errors === undefined)
                    return;
                if (key in errors) {
                    area.classList.add(errorClass);
                    message.innerHTML = errors[key].join("<br>");
                }
            }
        })
            .finally(() => {
            enableEventElement(event);
            return false;
        });
    });
};
/**
 * ログアウト処理
 *
 * ログアウトはページ内に複数のボタンがあることを想定している。
 * ヘッダー以外にボタンがある可能性を考慮。
 */
const activateLogoutButtons = () => {
    const logoutButtons = document.querySelectorAll(".logoutButton");
    if (logoutButtons.length === 0)
        return;
    // initialize
    if (BtixConstant.debugMode)
        window.console.log("initialize: logoutButton", logoutButtons);
    logoutButtons.forEach((logoutButton) => {
        logoutButton.addEventListener(BtixConstant.touchOrClickEvent(), (event) => {
            disableEventElement(event);
            axios
                .delete(BtixConstant.apiUrl.logOut, BtixConstant.axiosRequestConfig)
                .then((response) => {
                window.console.log(response);
                window.location.href = event.target.dataset.redirectUrl || BtixConstant.defaultAfterLogoutUrl;
            })
                .catch((error) => {
                if (!("isAxiosError" in error)) {
                    window.console.log(error);
                    throw new Error("Error occured.");
                }
                if (BtixConstant.debugMode)
                    window.console.log(error.response);
                const response = error.response;
                const errors = response.data.errors;
                window.console.log("Logout Error", errors);
                window.alert("ERROR: ログアウトできませんでした。");
            })
                .finally(() => {
                // enableEventElement(event);
                return false;
            });
        });
    });
};
